import React from 'react'

import { CopyButton } from '@components/common/CopyButton'
import { ButtonGroup, useMediaQueryContext } from '@fourthwall/components'

import { DashboardSection } from '../DashboardSection'
import * as S from './styled'
import type { DashboardItemViewHeaderProps } from './types'

export const DashboardItemViewHeader = ({
  name,
  title,
  link,
  backButton,
  toolbar,
  status,
}: DashboardItemViewHeaderProps) => {
  const media = useMediaQueryContext()

  const getTitle = () => {
    if (!title && !link) return null

    return (
      <>
        {link && (
          <S.TitleLink>
            <CopyButton
              appearance={media.laptop ? 'primary' : 'secondary'}
              href={link.url}
              label={link.label}
              referrerPolicy={link.referrerPolicy}
              copyText={link.copyUrl || link.url}
              copyLabel="Copy link"
            />
          </S.TitleLink>
        )}
        {title && title}
      </>
    )
  }

  const renderStatus = () => {
    return status && <S.StatusWrapper>{status}</S.StatusWrapper>
  }

  const renderTopContent = () => (
    <>
      <S.BackButtonWrapper>{backButton}</S.BackButtonWrapper>
      {!media.tablet && toolbar}
    </>
  )

  const renderToolbarContent = () => {
    if (!media.tablet) return null

    return (
      <ButtonGroup align="center">
        {renderStatus()}
        {toolbar}
      </ButtonGroup>
    )
  }

  return (
    <DashboardSection
      name={name}
      title={getTitle()}
      bottomContent={!media.tablet && renderStatus()}
      topContent={renderTopContent()}
      toolbarContent={renderToolbarContent()}
      bottomMargin="large"
    />
  )
}
